import MuiCard from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import { styled } from '@mui/system'

export const CardStyled = styled(MuiCard)``

export const CardContentStyled = styled(CardContent)``

export const CardActionsStyled = styled(CardActions)``
